export class CaseNote {
    caseId: number;
    noteText: string;
    caseNoteId ? = 0;
}
